import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NavController} from '@ionic/angular';
import { NavigationService } from 'src/providers/navigation/navigation.service';

/**
 * Generated class for the TextBuildingServicesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-text-building-services',
  templateUrl: 'text-building-services.html',
  styleUrls:['./text-building-services.scss']
})
export class TextBuildingServicesPage {
  previousUrl:string;
  constructor(
    public navCtrl: NavController, 
    public router:Router,
    private navService:NavigationService
  ) {
    this.previousUrl = this.navService.getPreviousUrl();
    console.log('previousUrl', this.previousUrl)
  }

  ionViewDidEnter() {
    console.log('ionViewDidEnter TextBuildingServicesPage');
  }

}
